import ApiService from "../../../services/ApiService";
import Logger from "../../../services/Logger";

const UserContactService = {
    postContact: async (company, firstName, lastName, email, subject, content, extra = {}) => {
        let body = {
            company: company,
            firstName: firstName,
            lastName: lastName,
            email: email,
            subject: subject,
            content: content,
            ...extra,
        };

        // Logger.log(body);

        const result = await ApiService.postData("/home/contact", body);
        // Logger.log(result);

        if (result && result.code === "FAILURE") {
            throw result.message;
        }
    },
};

export default UserContactService;
